import i18n from 'i18next';

export interface LocalizedField {
    en: string;
    fr: string;
}

export const getLocalizedFieldName = (fieldName: string) => {
    const currentLanguage = i18n.language;
    if (currentLanguage === 'fr') {
        return `${fieldName}Fr`;
    }
    return fieldName;
};

export const activeLocale = () => i18n.language;
